export default (value) => value === true || value === '1' || value === 'true';
